(function(){
function ready(f){if(document.readyState!=='loading'){f()}else{document.addEventListener('DOMContentLoaded',f)}}
ready(function(){
var gal=document.querySelector('[data-nq-gallery]');
if(gal){
var slides=[].slice.call(gal.querySelectorAll('[data-nq-slide]'));
var thumbs=[].slice.call(gal.querySelectorAll('[data-nq-thumb]'));
var cur=0;
var show=function(i){
if(!slides.length){return}
cur=(i+slides.length)%slides.length;
slides.forEach(function(s,k){s.classList.toggle('is-active',k===cur)});
thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===cur);t.setAttribute('aria-current',k===cur?'true':'false')});
var im=slides[cur].querySelector('img');
if(im){im.loading='eager'}
};
thumbs.forEach(function(t,k){t.addEventListener('click',function(){show(k)})});
var pv=gal.querySelector('[data-nq-prev]');
var nx=gal.querySelector('[data-nq-next]');
if(pv){pv.addEventListener('click',function(){show(cur-1)})}
if(nx){nx.addEventListener('click',function(){show(cur+1)})}
var main=gal.querySelector('[data-nq-main]');
var sx=null;
if(main){
main.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
main.addEventListener('touchend',function(e){if(sx===null){return}var dx=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(dx)>40){show(dx<0?cur+1:cur-1)}},{passive:true});
}
show(0);
}
var form=document.getElementById('nq-product-form');
if(form){
var setText=function(sel,val){[].forEach.call(document.querySelectorAll(sel),function(el){el.textContent=val})};
var setShow=function(sel,val){[].forEach.call(document.querySelectorAll(sel),function(el){el.textContent=val||'';el.hidden=!val})};
var sync=function(){
var c=form.querySelector('input[name=id]:checked');
if(!c){return}
var d=c.dataset;
var n=parseInt(d.count,10)||1;
setText('[data-nq-now]',d.price);
setShow('[data-nq-compare]',d.compare);
setShow('[data-nq-pill]',d.save);
setText('[data-nq-name]',d.name);
setText('[data-nq-perks]',(n>1?n+' free sleep masks':'free sleep mask')+' · free digital wellness e-book · free tracked US shipping · estimated delivery 10–12 business days · 30-day returns');
};
form.addEventListener('change',sync);
form.addEventListener('submit',function(e){if(!form.querySelector('input[name=id]:checked')){e.preventDefault()}});
window.addEventListener('pageshow',sync);
sync();
}
});
})();
